module.exports = __webpack_public_path__ + "img/lost-prayer-to-the-sacred-winds.fe1a3c30.webp";